import { createStore } from "owa-satcheljs";
import type CommandBarActionStore from "./schema/CommandBarActionStore";

const defaultCommandBarActionStore = {
    surfaceActions: [],
    overflowActions: [],
};

export const getStore: () => CommandBarActionStore = createStore<CommandBarActionStore>("commandBarAction", defaultCommandBarActionStore);
export default getStore;
